import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=01a13d18&scoped=true&"
import script from "./ShowVideo.vue?vue&type=script&lang=ts&"
export * from "./ShowVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ShowVideo.vue?vue&type=style&index=0&id=01a13d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a13d18",
  null
  
)

export default component.exports